import * as React from "react";
import {navigate} from '~/router';
import SaleStepHelp from "../../components/sales/SaleStepHelp";

class SaleHelpDesktop extends React.Component<any, any> {
  onBack = () => {
    navigate('pos.mobile.history');
  }

  render() {
    return (
      <SaleStepHelp onBack={this.onBack} />
    );
  }
}

export default SaleHelpDesktop;
